'use strict';

var scrollbarWidth;
var _ = require('underscore/underscore');


SVGElement.prototype.hasClass = function (className) {
    return new RegExp('(\\s|^)' + className + '(\\s|$)').test(this.getAttribute('class'));
};


$.easing.easeOutQuart = function (x, t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
};


SVGElement.prototype.addClass = function (className) {
    if (!this.hasClass(className)) {
        this.setAttribute('class', this.getAttribute('class') + ' ' + className);
    }
};


SVGElement.prototype.removeClass = function (className) {
    var removedClass = this.getAttribute('class').replace(new RegExp('(\\s|^)' + className + '(\\s|$)', 'g'), '$2');
    if (this.hasClass(className)) {
        this.setAttribute('class', removedClass);
    }
};


SVGElement.prototype.toggleClass = function (className) {
    if (this.hasClass(className)) {
        this.removeClass(className);
    } else {
        this.addClass(className);
    }
};


$.fn.flashClass = function (className, delay) {
    var self = this;
    var timeout;
    this.addClass(className);
    clearTimeout(this.data('timeout'));
    timeout = setTimeout(function () {
        if (typeof self === 'object' && self.length) {
            self.removeClass(className);
            self.data('timeout', null);
        }
    }, delay);
    this.data('timeout', timeout);

    return this;
};

$.fn.unFlashClass = function (className, delay) {
    var self = this;
    var timeout;
    this.removeClass(className);
    clearTimeout(this.data('timeout'));
    timeout = setTimeout(function () {
        if (typeof self === 'object' && self.length) {
            self.addClass(className);
            self.data('timeout', null);
        }
    }, delay);
    this.data('timeout', timeout);

    return this;
};


var urlsType = {};
for (var url in window.Urls) {
    if (window.Urls.hasOwnProperty(url)) {
        var urlStr = window.Urls[url]();
        if (urlStr) {
            urlsType[urlStr] = (/popup$/i).test(url) ? 'popup' : 'page';
        }
    }
}


if (typeof Object.assign !== 'function') {
    Object.assign = function (target) {
        if (target == null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source != null) {
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
        }

        return target;
    };
}

// Restricts input for the set of matched elements to the given inputFilter function.
(function ($) {
    $.fn.inputFilter = function (inputFilter) {
        return this.on('input keydown keyup mousedown mouseup select contextmenu drop', function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty('oldValue')) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
                this.value = '';
            }
        });
    };
})(jQuery);


// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
            || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)        {
        window.requestAnimationFrame = function (callback) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () {
                callback(currTime + timeToCall);
            },
            timeToCall);
            lastTime = currTime + timeToCall;

            return id;
        };
    }

    if (!window.cancelAnimationFrame)        {
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
    }
})();


jQuery.fn.serializeObject = function () {
    var arrayData;
    var objectData;
    arrayData = this.serializeArray();
    objectData = {};

    $.each(arrayData, function () {
        var value;
        var name = this.name.slice(-2) === '[]' ? this.name.slice(0, -2) : this.name;

        if (this.value != null) {
            value = this.value;
        } else {
            value = '';
        }

        if (objectData[name] != null) {
            if (!objectData[name].push) {
                objectData[name] = [objectData[name]];
            }

            objectData[name].push(value);
        } else {
            objectData[name] = value;
        }
    });

    return objectData;
};



$.fn.onCustom = function (eventName, callback) {
    this.each(function (ind, item) {
        var listeners = $(item).data('listeners');
        listeners && listeners[eventName] && listeners[eventName].push(callback);
    });

    return this;
};


$.fn.triggerCustom = function (eventName, options) {
    this.each(function (ind, item) {
        var listeners = $(item).data('listeners')[eventName];
        for (var i = 0 ; i < listeners.length; i++) {
            listeners[i]({}, options);
        }
    });

    return this;
};


$.fn.offCustom = function (eventName) {
    this.each(function (ind, item) {
        var listeners = $(item).data('listeners');
        listeners && listeners[eventName] && (listeners[eventName] = []);
    });

    return this;
};


//escaping all control symbols inside Media Base Url to use it as regular expression + check url ends with file
//extension: // \.\w{2, 7}$  (.ai, .mp4, .sketch, etc..)
var mediaRegex = new RegExp('^' + app.settings.mediaUrl.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&') + '.*\\.\\w{2,7}$');
var originRegex = new RegExp('^' + window.location.origin.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'));

// Generate unique cid for object
//
var _cid = 0;


const utils = {

    encodeParams: function (data) {
        return [
            data.square,
            data.rooms,
            data.bathrooms,
            data.tp,
            data.removeOldFinish,
            data.addWalls
        ].join(',');
    },


    decodeParams: function (str) {
        let data = str.split(',');

        return {
            square: data[0],
            rooms: data[1],
            bathrooms: data[2],
            tp: data[3],
            removeOldFinish: data[4],
            addWalls: data[5],
            isValid: data[0] && data[1] && data[2] && data[3] && data[4] && data[5]
        };
    },


    animateWindowScroll: function (scrollTop, duration, easing) {
        app.state.preventMenuShowOnScroll = true;
        $('body, html').animate({'scrollTop': scrollTop}, duration, easing || 'swing');

        setTimeout(function () {
            app.state.preventMenuShowOnScroll = false;
        }, duration + 100);
    },


/* eslint-disable */
    isValidEmail: function (email) {
        var re = /^(.+)@(.+){2,}\.(.+){2,}$/;

        return re.test(email);
    },


    //check format as tinkoff treats phone: remove all symbols except digits, the remainder should be 1 up to 18 digits
    isValidPhone: function (phone) {
        phone = phone.replace(/[^\d]/g, '');

        return phone.length >= 1 && phone.length <= 18;
    },

    animateNumber: function ($number, fromValue, toValue, delay, duration, cb, easing, separator, digits) {
        var sepReg = new RegExp('\\' + (separator || '') + '+', 'g');
        var start_val = fromValue == undefined ? parseFloat($number.text().replace(sepReg, ''), 10) : fromValue;
        var end_val = toValue - 0;
        var start_time = +new Date() + delay;
        var end_time = start_time + duration;
        var self = this;
        digits = digits || 3;

        if (start_val < end_val) {
            start_val = Math.ceil(start_val);
            end_val = Math.floor(end_val);
        } else {
            start_val = Math.floor(start_val);
            end_val = Math.ceil(end_val);
        }

        window.cancelAnimationFrame($number.data('animateNumberTimer'));

        changeNumber();

        function changeNumber() {
            var cur_time = Math.min(Math.max(+new Date(), start_time), end_time);
            var per; var val;

            if (duration > 0) {
                per = (cur_time - start_time) / duration;
            } else {
                per = 1;
            }

            //val = Math.round(start_val + (end_val - start_val) * per);
            val = Math.round(utils.easingFunctions(start_val, end_val, per, easing));

            if (per == 1) {
                val = toValue - 0;
            }

            var regExp = new RegExp('\\B(?=(\\d{' + digits + '})+(?!\\d))', 'g');

            cb ? cb(val) : $number.text(val.toString().replace(regExp, separator || ''));

            if (per < 1) {
                $number.data('animateNumberTimer', window.requestAnimationFrame(changeNumber));
            }
        }
    },

    easingFunctions: function (st, ed, per, easing) {
        var functions = {
            //simple linear tweening - no easing, no acceleration
            linearTween: function (t, b, c, d) {
                return c * t / d + b;
            },

            // quadratic easing in - accelerating from zero velocity
            easeInQuad: function (t, b, c, d) {
                t /= d;

                return c * t * t + b;
            },

            // quadratic easing out - decelerating to zero velocity
            easeOutQuad: function (t, b, c, d) {
                t /= d;

                return -c * t * (t - 2) + b;
            },

            // quadratic easing in/out - acceleration until halfway, then deceleration
            easeInOutQuad: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t + b;
                t--;

                return -c / 2 * (t * (t - 2) - 1) + b;
            },

            // cubic easing in - accelerating from zero velocity
            easeInCubic: function (t, b, c, d) {
                t /= d;

                return c * t * t * t + b;
            },

            // cubic easing out - decelerating to zero velocity
            easeOutCubic: function (t, b, c, d) {
                t /= d;
                t--;

                return c * (t * t * t + 1) + b;
            },

            // cubic easing in/out - acceleration until halfway, then deceleration
            easeInOutCubic: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t * t + b;
                t -= 2;

                return c / 2 * (t * t * t + 2) + b;
            },

            // quartic easing in - accelerating from zero velocity
            easeInQuart: function (t, b, c, d) {
                t /= d;

                return c * t * t * t * t + b;
            },

            // quartic easing out - decelerating to zero velocity
            easeOutQuart: function (t, b, c, d) {
                t /= d;
                t--;

                return -c * (t * t * t * t - 1) + b;
            },

            // quartic easing in/out - acceleration until halfway, then deceleration
            easeInOutQuart: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t * t * t + b;
                t -= 2;

                return -c / 2 * (t * t * t * t - 2) + b;
            },

            // quintic easing in - accelerating from zero velocity
            easeInQuint: function (t, b, c, d) {
                t /= d;

                return c * t * t * t * t * t + b;
            },

            // quintic easing out - decelerating to zero velocity
            easeOutQuint: function (t, b, c, d) {
                t /= d;
                t--;

                return c * (t * t * t * t * t + 1) + b;
            },

            // quintic easing in/out - acceleration until halfway, then deceleration
            easeInOutQuint: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t * t * t * t + b;
                t -= 2;

                return c / 2 * (t * t * t * t * t + 2) + b;
            },

            // sinusoidal easing in - accelerating from zero velocity
            easeInSine: function (t, b, c, d) {
                return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
            },

            // sinusoidal easing out - decelerating to zero velocity
            easeOutSine: function (t, b, c, d) {
                return c * Math.sin(t / d * (Math.PI / 2)) + b;
            },

            // sinusoidal easing in/out - accelerating until halfway, then decelerating
            easeInOutSine: function (t, b, c, d) {
                return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
            },

            // exponential easing in - accelerating from zero velocity
            easeInExpo: function (t, b, c, d) {
                return c * Math.pow( 2, 10 * (t / d - 1) ) + b;
            },

            // exponential easing out - decelerating to zero velocity
            easeOutExpo: function (t, b, c, d) {
                return c * ( -Math.pow( 2, -10 * t / d ) + 1 ) + b;
            },

            // exponential easing in/out - accelerating until halfway, then decelerating
            easeInOutExpo: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * Math.pow( 2, 10 * (t - 1) ) + b;
                t--;

                return c / 2 * ( -Math.pow( 2, -10 * t) + 2 ) + b;
            },

            // circular easing in - accelerating from zero velocity
            easeInCirc: function (t, b, c, d) {
                t /= d;

                return -c * (Math.sqrt(1 - t * t) - 1) + b;
            },

            // circular easing out - decelerating to zero velocity
            easeOutCirc: function (t, b, c, d) {
                t /= d;
                t--;

                return c * Math.sqrt(1 - t * t) + b;
            },

            // circular easing in/out - acceleration until halfway, then deceleration
            easeInOutCirc: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
                t -= 2;

                return c / 2 * (Math.sqrt(1 - t * t) + 1) + b;
            }
        };

        return functions[easing](per, st, ed - st, 1);
    },
    /*eslint-enable */


    blockScrollOnSwipe: function (el) {
        let x;
        let y;
        let scroll;

        const onTouchStart = function (e) {
            if (e.touches.length > 1) {
                return;
            }

            scroll = undefined;
            x = e.touches[0].pageX;
            y = e.touches[0].pageY;
        };

        const onTouchMove = function (e) {
            if (scroll === 'v') {
                return;
            }

            const dX = e.touches[0].pageX - x;
            const dY = e.touches[0].pageY - y;

            if (scroll === 'h') {
                e.preventDefault();
            } else if (Math.abs(dX) > 5 || Math.abs(dY) > 5) {
                scroll = Math.abs(dX) > Math.abs(dY) ? 'h' : 'v';
            }
        };

        el.addEventListener('touchstart', onTouchStart, {
            passive: false
        });
        el.addEventListener('touchmove', onTouchMove, {
            passive: false
        });
    },


    PageVisibilityManager: (function () {
            // Set the name of the hidden property and the change event for visibility
        var hidden; var visibilityChange;
        if (typeof document.hidden !== 'undefined') {
            hidden = 'hidden';
            visibilityChange = 'visibilitychange';
        } else if (typeof document.mozHidden !== 'undefined') {
            hidden = 'mozHidden';
            visibilityChange = 'mozvisibilitychange';
        } else if (typeof document.msHidden !== 'undefined') {
            hidden = 'msHidden';
            visibilityChange = 'msvisibilitychange';
        } else if (typeof document.webkitHidden !== 'undefined') {
            hidden = 'webkitHidden';
            visibilityChange = 'webkitvisibilitychange';
        }

        var add = function (callback) {
            if (!hidden) {
                return false;
            }
            document.addEventListener(visibilityChange, callback);
        };

        var remove = function (callback) {
            if (!hidden) {
                return false;
            }
            document.removeEventListener(visibilityChange, callback);
        };

        var isHidden = function () {
            return document[hidden];
        };

        return {
            addEventListener : add,
            removeEventListener: remove,
            isPageHidden: isHidden
        };
    })(),


    //create blank video and check if it can be autoplayed without direct user interaction or not
    detectVideoAutoplayFeature: function (cb) {
        cb(true);

        return;

        const base64BlankVideo = 'data:video/mp4;base64,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';
        const $video = $('<video muted playsinline crossorigin loop preload="auto">')
            .attr('src', base64BlankVideo)
            .css({
                'position': 'absolute',
                'top': -9999
            })
            .appendTo('body');
        const playPromise = $video[0].play();

        // browsers that don't yet support this functionality,
        // playPromise won't be defined.
        if (playPromise !== undefined) {
            let res;
            playPromise
                .then(() => {
                    res = true;
                })
                .catch(() => {
                    res = false;
                })
                .finally(() => {
                    $video.remove();
                    cb(res);
                });
        } else {
            $video.remove();
            cb(true); //for older browsers autoplay is almost certanly enabled
        }
    },


    cid: function (data) {
        if (typeof data !== 'undefined') {
            return Object.assign({}, data, {_cid: data._cid || ++_cid});
        }

        return ++_cid;
    },


    updateLinksAttributes: function ($container) {
        $('a', $container).each(function () {
            var $link = $(this);

            if ($link.hasClass('u-skipUrlParser')) {
                return;
            }

            var href = $link.attr('href');
            var linkType = 'inner';

            if (/\.\w{2,7}$/i.test(href)) {
                linkType = 'file';
            }
            if (/^tel\:/i.test(href)) {
                linkType = 'tel';
            }
            if (/^mailto\:/i.test(href)) {
                linkType = 'mail';
            }
            if (/^http/i.test(href)) {
                linkType = 'outer';
            }
            if (originRegex.test(href)) {
                $link.attr('href', href.substring(window.location.origin.length));
                linkType = 'inner';
            }
            if (/^#/i.test(href)) {
                linkType = 'anchor';
            }
            if (mediaRegex.test(href)) {
                linkType = 'file';
            } //in case of mediaUrl starts with http and "/^http/i" conditional statement overrides file conditional statement "/\.\w{2,7}$/i"

            if (linkType === 'outer' || linkType === 'file') {
                $link.attr('target', '_blank');
            } else {
                $link.removeAttr('target');
            }

            if (urlsType[$link.attr('href')] === 'page') {
                linkType = 'page'; //no router processing, needs reload
            }

            $link.toggleClass('u-Outer', linkType === 'outer');
            $link.toggleClass('u-Route', linkType === 'inner');
            $link.toggleClass('u-Tel', linkType === 'tel');
            $link.toggleClass('u-Mail', linkType === 'mail');
            $link.toggleClass('u-File', linkType === 'file');
            $link.toggleClass('u-Anchor', linkType === 'anchor');

            if (linkType === 'file') {
                $link.attr('data-type', href.match(/\.(\w{2,7})$/i)[1]);
            }

            if (linkType === 'outer') {
                $link.attr('rel', 'noreferrer noopener');
            }
        });
    },


    createEmptyPromise: function () {
        return new Promise(function (resolve) {
            resolve();
        });
    },


    getFocusBack: function () {
        $('<input style="position: absolute;left: -999px;font-size:20px" type="text"/>')
            .appendTo('body')
            .css({'top': $(window).scrollTop()})
            .focus()
            .remove();
    },


    //для заданного элемента возвращает значения 6 переменных матрицы трансформации
    getCurrentTranslate: function (obj) {
        var cs = window.getComputedStyle(obj, null);

        var tr = cs.getPropertyValue('-webkit-transform') ||
                 cs.getPropertyValue('transform');

        if (!tr || tr === 'none') {
            return [0, 0];
        }

        //getComputedStyle всегда возвращает матрицу трансформации,
        //где учтены уже повороты, скейлы, сдвиги и skew
        var res = tr.split('(')[1];
        var res = res.split(')')[0];
        var res = res.split(',');

        return [res[4] - 0, res[5] - 0]; //приводим к числу из строки
    },


    waitForTransitionEnd: function ($obj, property, cb, safeTimeout) {
        var transEndEventNames = {
            'transition'       : 'transitionend',
            'WebkitTransition' : 'webkitTransitionEnd',
            'MozTransition'    : 'transitionend',
            'OTransition'      : 'oTransitionEnd',
            'msTransition'     : 'MSTransitionEnd'
        };

        var transitionSafeTimeout;

        var getTransitionEndName = function () {
            if (!window.getComputedStyle || !document.documentElement) {
                return 'transitionend';
            }

            var styles = window.getComputedStyle(document.documentElement, '');

            for (var i in transEndEventNames) {
                if (styles[i] !== undefined) {
                    return transEndEventNames[i];
                }
            }

            return 'transitionend';
        };

        var transEndEventName = getTransitionEndName();

        var transitionEndCallback = function (e) {
            if (e) {
                var prop = e.originalEvent.propertyName.toLowerCase();
                if (!$(e.target).is($obj)) {
                    return;
                }
                if (prop.indexOf(property) === -1) {
                    return;
                }
            }

            $obj.off(transEndEventName, transitionEndCallback);

            clearTimeout(transitionSafeTimeout);

            cb();
        };

        var resetAllHandlers = function () {
            $obj.off(transEndEventName, transitionEndCallback);

            clearTimeout(transitionSafeTimeout);
        };


        $obj.on(transEndEventName, transitionEndCallback);

        transitionSafeTimeout = setTimeout(transitionEndCallback, safeTimeout === undefined ?
            this.getTransitionDuration($obj[0], property) + 100 : safeTimeout);

        return resetAllHandlers;
    },



    getScrollbarWidth: function () {
        if (scrollbarWidth !== undefined) {
            return scrollbarWidth;
        }

        var outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.width = '100px';
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

        document.body.appendChild(outer);

        var widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = 'scroll';

        // add innerdiv
        var inner = document.createElement('div');
        inner.style.width = '100%';
        outer.appendChild(inner);

        var widthWithScroll = inner.offsetWidth;

        // remove divs
        outer.parentNode.removeChild(outer);

        scrollbarWidth = widthNoScroll - widthWithScroll;

        return scrollbarWidth;
    },


    queryUrlGetParam: function (variable, url) {
        if (!url) {
            return '';
        }

        try {
            var queryParts = url.split('?');
            var query = queryParts[queryParts.length - 1];

            if (!query) {
                return '';
            }

            var v = query.split('&');
            for (var i = 0; i < v.length; i++ ) {
                var p = v[i].split('=');
                if (p[0] === variable) {
                    if (p.length > 1) {
                        return decodeURIComponent(p[1]);
                    } else {
                        return ''; //if variable for empty param, without value
                    }
                }
            }
        } catch (e) {
            console.log(e);
        }
    },

    /* eslint-disable */
    smoothDamp: function (current, target, dat, smoothTime, maxSpeed, deltaTime) {
        smoothTime = Math.max(0.0001, smoothTime);

        var num = 2 / smoothTime;
        var num2 = num * deltaTime;
        var num3 = 1 / (1 + num2 + 0.48 * num2 * num2 + 0.235 * num2 * num2 * num2);
        var num4 = current - target;
        var num5 = target;
        var num6 = maxSpeed * smoothTime;
        var num7; var num8;

        num4 = Math.min(Math.max(num4, -num6), num6);

        target = current - num4;
        num7 = (dat.velocity + num * num4) * deltaTime;
        dat.velocity = (dat.velocity - num * num7) * num3;
        num8 = target + (num4 + num7) * num3;

        if ((num5 - current > 0) === (num8 > num5)) {
            num8 = num5;
            dat.velocity = (num8 - num5) / deltaTime;
        }

        return num8;
    }
    /* eslint-enable */

};

utils.ImagesLoadQueue = function (params) {
    params = params || {};
    this.delay = params.delay || 100;
    this.queue = [];
    this._proceed = this._proceed.bind(this);
};

utils.ImagesLoadQueue.prototype = {
    clear() {
        this.queue = [];
    },

    stop() {
        clearTimeout(this.proceedTimeout);
    },

    start() {
        this._proceed();
    },

    _proceed() {
        if (!this.queue.length) {
            return;
        }

        const $image = this.queue[0];
        $image.attr('data-requested', true);

        const $picture = $image.parent();

        $picture.find('source, img').each(function () {
            var srcset = this.getAttribute('data-srcset');
            var sizes = this.getAttribute('data-sizes');
            var src = this.getAttribute('data-src');
            srcset && this.setAttribute('srcset', srcset);
            sizes && this.setAttribute('sizes', sizes);
            src && this.setAttribute('src', src);
        });

        this.queue.shift();
        if (!this.queue.length) {
            return;
        }

        this.proceedTimeout = setTimeout(this._proceed, this.delay);
    },

    add($image) {
        if ($image.attr('data-requested')) {
            return;
        }
        this.queue.push($image);
    }
};


utils.HeaderAnimator = function ($elem) {
    this.$elem = $elem;
    this.prevContent = $elem.html();

    const str = $elem.text();
    const split = str.split('');
    const shift = 20 * app.settings.scale;
    const speed = 150;
    const delay = 70;
    this.duration = speed;

    $elem.html(split.map((letter, index) => {
        const style = `
            position: relative;
            display: inline-block;
            opacity:0;
            will-change: opacity, transform;
            transform: translateX(${shift}px);
            transition: ${speed}ms ease-out ${delay * index}ms
        `;
        this.duration += delay;

        return `<span style="${style}">${letter}</span>`;
    }).join(''));
};

utils.HeaderAnimator.prototype = {

    fire(delay) {
        delay = delay || 0;

        setTimeout(() => {
            this.$elem.find('span').each((index, item) => {
                item.style.opacity = '';
                item.style.transform = '';
            });
        }, delay);

        // setTimeout(() => {
        //     this.$elem.html(this.prevContent);
        // }, this.duration);
    }
};


/**
 * Плагин для реализации свайп жестов утягивания-вытягивания элементов, можно для свайза картинок в галерее использовать
 */
/* eslint-disable */
(function ($, undefined) {
    $.fn.Swiper = function (options) {
        var Swiper = function (options, $elems) {
            this.options = _.clone(options);

            this.$swipes = $elems;

            this.isTouch = window.matchMedia('(hover: none)').matches;

            _.defaults(this.options, {
                actionTreshold: 25, //сколько надо пройти пальцем чтобы считать что был жест вытягивания/утягивания
                rubberBand: true, //флаг что нужна пружинка
                rubberBandForce: 1 / 1.55, //чем больше значение дроби, тем жесче "пружина", 1/1 нет пружины, 1/<1 обратная "пружина"
                tolerance: 5, //сколько надо сдвинуть пальцем в нужном направлении, чтобы понять что мы хотим свайпить
                disableOnScaled: true, //запрещаем что-либо обрабатывать если экран отскейлен
                autoAnimate: true, //флаг что если мы прошли пальцем достаточное расстояние для перехода в новое состояния, мы сами плавно доанимируем его до этого состояния, а потом уже вызовем колбек
                immediateCallback: false, //флаг что если мы прошли пальцем достаточное расстояние для перехода в новое состояния, то мы сразу вызываем колбек, независимо от того будем ли мы сами доанимировать элемент до нового состояния или нет
                maxTransitionSpeed: 400,
                minTransitionSpeed: 100,
                stopOnItems: ['input', 'textarea', '.no-swiper'] //jQuery селекторы элементов над которыми плагин не должен начинать свайпить
            });
        };

        Swiper.prototype = {

            initialize: function () {
                _.bindAll(this, 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onMouseStart', 'onMouseMove', 'onMouseEnd');

                if (this.isTouch) {
                    this.$swipes.on('touchstart', this.onTouchStart);
                    this.$swipes.on('touchmove', this.onTouchMove);
                    this.$swipes.on('touchend touchcancel', this.onTouchEnd);
                } else {
                    this.$swipes.on('mousedown', this.onMouseStart);
                }
            },


            destroy: function () {
                if (this.$swipes) {

                    if (this.isTouch) {
                        this.$swipes.off('touchstart', this.onTouchStart);
                        this.$swipes.off('touchmove', this.onTouchMove);
                        this.$swipes.off('touchend touchcancel', this.onTouchEnd);
                    } else {
                        this.$swipes.off('mousedown', this.onMouseStart);
                        $(window).off('mousemove', this.onMouseMove);
                        $(window).off('mouseup', this.onMouseEnd);
                    }

                    this.$swipes.data('swiper', null);
                }

                return this.$swipes;
            },


            onMouseStart: function (e) {
                e.originalEvent.touches = [{
                    identifier: 1,
                    clientX: e.originalEvent.clientX,
                    clientY: e.originalEvent.clientY
                }];

                this.onTouchStart(e);

                $(window).off('mousemove', this.onMouseMove);
                $(window).off('mouseup', this.onMouseEnd);
                $(window).on('mousemove', this.onMouseMove);
                $(window).on('mouseup', this.onMouseEnd);
            },


            onMouseMove: function (e) {
                e.originalEvent.touches = [{
                    identifier: 1,
                    clientX: e.originalEvent.clientX,
                    clientY: e.originalEvent.clientY
                }];

                this.onTouchMove(e);
            },


            onMouseEnd: function (e) {
                e.originalEvent.touches = [];

                this.onTouchEnd(e);

                $(window).off('mousemove', this.onMouseMove);
                $(window).off('mouseup', this.onMouseEnd);
            },


            onTouchStart: function (e) {
                e = e.originalEvent;
                var touches = e.touches;
                var options = this.options;
                var self = this;
                var isScaled = window.innerWidth != document.documentElement.clientWidth && this.isTouch;

                // не начинаем детектить жест, если палец над запрещенным элементом.
                if (options.stopOnItems && options.stopOnItems.length) {
                    var $closest = $(e.target).closest(options.stopOnItems.join(', '));
                    if ($closest.length && this.$swipes.find($closest).length) {
                        return;
                    }
                }

                //если уже идет анимации доводки до нового состояния  тогда выходим
                if (this.animating) {
                    return;
                }

                //если уже отловили одно нажатие пальца и следим за ним
                //все последующие пальцы игнорируем
                if (this.data) {
                    return;
                }

                //если на экране сразу больше одного пальца тогда ничего не делаем,
                //следить ни за чем не будем, пока юзер сам не отпустит все пальцы, и не начнет с одного пальца
                if (touches.length != 1) {
                    return;
                }

                //если есть нативный скейл окна тогда смотрим должны мы выйти или нет
                if (((e.scale && e.scale !== 1) || isScaled) && options.disableOnScaled) {
                    return;
                }

                this.data = {};
                //получаем данные о том, в каких направлениях можно двигать объект
                //его граничные положения, и на сколько надо сдвинуть чтобы он сместился с одного граниченого положения на другое
                this.data.constraints = options.getCurrentConstraints($(e.target));

                this.data.id = touches[0].identifier; //сохраняем идентификатор касания, чтобы потом реагировать только на него
                this.data.clientX = touches[0].clientX;
                this.data.clientY = touches[0].clientY;
                this.data.lastTime = +new Date();
                this.data.shift = 0;
                this.data.velocity = 0;

                //если передан список элементов которые должны смещаться при движении пальзем по this.$swipes
                //тогда двигаем только элементы из этого списка, иначе дефолтное поведение - кого пальцем тянем, того и двигаем
                this.data.$moveItems = this.data.constraints.$moveItems || this.$swipes;

                this.data.$moveItems = this.data.$moveItems.filter(function () {
                    return this.nodeType != 3;
                }); //убираем текстовые ноды если таковые попались всреди элементов

                //элемент по которому мы будем определять окончание транзишенов
                //а также по котору будем смотреть есть сейчас анимация (не наша) или нет
                this.data.$referenceItem = this.data.constraints.$referenceItem || this.data.$moveItems.last();

                //фикс непонятного бага, видел на андроиде, что this.data.$referenceItem пустой, как и почему не понял
                if (!this.data.$referenceItem.length) {
                    this.data.$referenceItem = this.data.$moveItems.last();
                    console.log('No reference object found, use substitution: ', this.data.constraints, $(e.target), this.data.$moveItems, this.$swipes);
                }

                //заранее в начале тача получаем даные о стилях и положении элементов
                //для тача это незначительная задержка, зато потом если это все-таки жест, будет гораздо оперативнее реагировать на первый сдвиг пальцем
                this.data.translate = [];
                this.data.oldStyle = [];
                this.data.$moveItems.each(function () {
                    var $obj = $(this);
                    self.data.translate.push(utils.getCurrentTranslate(this));
                    self.data.oldStyle.push($obj.attr('style'));
                });


                this.data.isTargetScrollable = !!(options.$scrollElements && $(e.target).closest(options.$scrollElements).length);

                //сохраняем текущее положение блока за который собираемся тянуть
                //если к моменту когда мы определим что происходит нужный нам жест мы увидим
                //что блок сместился, дл нас это плохой сигнал
                //лучше жест не применять, сокрее всего происходит какая либо анимация через транзишены и мы только ве испортим
                var rect = this.data.$referenceItem[0].getBoundingClientRect();
                this.data.targetX = rect.left;
                this.data.targetY = rect.top;
            },


            onTouchMove: function (e) {
                e = e.originalEvent;

                var touches = e.touches;
                var touch = touches[0];
                var data = this.data;
                var options = this.options;
                var tolerance = options.tolerance;
                var constraints = data && data.constraints;
                var self = this;
                var shift;
                var dirs;
                var dir;

                //если уже идет анимации доводки до нового состояния  тогда выходим
                if (this.animating) {
                    return;
                }

                //если onTouchStart мы инициализировали отслеживание за текущим жестом в onTouchStart
                //тогда выходим, например если изначально прикоснулись двумя пальцами, а потом один убрали
                if (!data) {
                    return;
                }

                //если на экране сразу больше одного пальца тогда ничего не делаем
                if (touches.length != 1) {
                    return;
                }

                //если есть нативный скейл окна тогда смотрим должны мы выйти или нет
                if (e.scale && e.scale !== 1 && options.disableOnScaled) {
                    return;
                }

                //если текущее касание не то, с которого начинали
                //тогда выходим, например если коснулись одним пальцем, потом другим, потом первый отпустили
                if (touch.identifier != data.id) {
                    return;
                }


                //если мы еще не поняли жест это или нет, или если поняли но он был в запрещенную сторону (тогда проверим еще раз в вдруг в нужную сторону уже сдвинли сколько надо)
                //отдельно рассматриваем ситуацию если жест был сделан на достаточное расстояние в запрещенном направлении и при этом мы на "разрешенном" для скрола объекте
                if (!this.started || (data.noActionConstraints && !data.isTargetScrollable)) {
                    //сначала смотрим в какие стороны палец на сколько ушел
                    dirs = {
                        up: data.clientY - touch.clientY,
                        down: touch.clientY - data.clientY,
                        left: data.clientX - touch.clientX,
                        right: touch.clientX - data.clientX
                    };

                    var max = 0;
                    var dir = '';


                    //теперь смотрим в какую сторону он шел больше всего
                    if (dirs.up > max) {
                        dir = 'up'; max = dirs.up;
                    }
                    if (dirs.down > max) {
                        dir = 'down'; max = dirs.down;
                    }
                    if (dirs.left > max) {
                        dir = 'left'; max = dirs.left;
                    }
                    if (dirs.right > max) {
                        dir = 'right'; max = dirs.right;
                    }

                    //если уже стартовали, но находимся здесь значит изначально стартовали в запрещенном направлении
                    //а теперь просто постоянно проверяем нет ли сдвига в разрешенном направлении чтобы включить реакцию на жест
                    //т.е. мы тут если выполнилась часть ...data.noActionConstraints && (!options.$sc...
                    //в данном случае нам не надо меряться сдвигами, а достаточно чтоюы был сдвиг больше tolerance в разрешенную сторону
                    var enoughAllowedDirectionMovement = false;

                    if (this.started) {
                        enoughAllowedDirectionMovement =
                            (constraints.up && dirs.up > tolerance) ||
                            (constraints.down && dirs.down > tolerance) ||
                            (constraints.left && dirs.left > tolerance) ||
                            (constraints.right && dirs.right > tolerance);
                    }


                    //если максимальный сдвиг достаточен для начала жеста, тогда смотрим куда был сдвиг: в разрешенном направлении или нет
                    if (max >= tolerance) {
                        //помечаем для себя что мы опознали жест и будем теперь следить за ним
                        //а вот будем ли мы на него реагировать, это решим дальше
                        //не реагируем мы если изначально повели пальцем в запрещенную сторону,
                        //или если элемент под пальцем уже сейчас анимируется, но не нами
                        this.started = true;

                        if (constraints[dir] || enoughAllowedDirectionMovement) {
                            //проверяем текущее положение блока за который собираемся тянуть
                            //если к моменту когда мы определим что происходит нужный нам жест мы увидим
                            //что блок сместился, для нас это плохой сигнал
                            //будем все отрабатывать, но объекты за пальцем таскать не будем, и не будем
                            //важно обрабатывать жест но не реагировать на него чтобы в нужное время вызывался preventDefault, поскольку иначе у нас начнет работать глобальный скрол и пр.
                            //лучше жест не применять, скорее всего происходит какая либо анимация через транзишены и мы только все испортим
                            var rect = data.$referenceItem[0].getBoundingClientRect();
                            if (data.targetX != rect.left || data.targetY != rect.top) {
                                data.noActionMovement = true; //ставим пометку почему мы просто слежим за жестом но не реагируем
                            }

                            //определем ось по которой мы будем двигать объект
                            var x = constraints.left || constraints.right ? Math.abs(data.clientX - touch.clientX) : 0;
                            var y = constraints.up || constraints.down ? Math.abs(data.clientY - touch.clientY) : 0;

                            data.axis = x > y ? 'x' : 'y';
                            data.translateInd = data.axis == 'x' ? 0 : 1; //индекс в массиве транслейтов который нужно менять чтобы осуществлять сдвиг по нужной оси

                            if (!data.noActionMovement) {
                                //перебираем все объекты
                                //и сохраняем их текущую скалькулированную матрицу трансформации, а также инлайн стиль целиком

                                //начинаем отсчитывать от текущего положения, чтобы не было рывка при вклюении реакции на жест,так то
                                data.clientX = touch.clientX;
                                data.clientY = touch.clientY;

                                data.$moveItems.addClass('swiping');
                            }
                            data.noActionConstraints = false; //снимаем пометку если она стояла ранее

                            options.onSwipeStart && options.onSwipeStart();
                        } else { //в данном направлении запрещены жесты
                            data.noActionConstraints = true; //ставим пометку почему мы просто следим за жестом но не реагируем
                        }
                    }
                }


                //если начали обслуживать жест (даже если start только что установили чуть выше)
                //то блокируем всякие дефолтные скролы
                if (this.started) {
                    //если мы свайпим поверх элемента с разрешенным скролом,
                    //тогда preventDefault не надо
                    if (data.isTargetScrollable) {
                        //блокируем любое дефолтное поведение браузера на разрешенном блоке скрола (в том числе и его внутренний скрол)
                        //если основной элемент свайпа сейчас в процессе анимации (не нашей)
                        //или если мы совершаем сдвиг в разрешщенном направлении
                        if (!data.noActionConstraints || data.noActionMovement) {
                            e.preventDefault();
                        }
                    } else {
                        e.preventDefault();//раз мы вошли в режим жеста, то блокируем любое дефолтное поведение браузера включая скролл
                    }
                }

                //если жест начат и нет флага что мы за ним просто наблюдаем но никак не реагируем
                if (this.started && !data.noActionConstraints && !data.noActionMovement) {
                    if (data.axis == 'x') {
                        shift = touch.clientX - data.clientX;
                        if (shift < 0) { //left
                            dir = 'left';
                            shift = -normalizeShift(-shift, constraints.left);
                        } else if (shift > 0) { //right
                            dir = 'right';
                            shift = normalizeShift(shift, constraints.right);
                        }
                    } else {
                        shift = touch.clientY - data.clientY;
                        if (shift < 0) { //up
                            dir = 'up';
                            shift = -normalizeShift(-shift, constraints.up);
                        } else if (shift > 0) { //down
                            dir = 'down';
                            shift = normalizeShift(shift, constraints.down);
                        }
                    }

                    data.$moveItems.each(function (ind, elem) {
                        var translate = data.translate[ind];
                        var old = translate[data.translateInd];

                        //здесь кастомная проверка на то, надо ли сдвигать сейчас данный конкретный элемент или не стоит
                        //если не стоит то его надо вернуть в исходное положение
                        if (!options.customMoveCheck || options.customMoveCheck($(this), shift)) {
                            translate[data.translateInd] += shift;
                        }

                        self.applyTransform(this, data.oldStyle[ind], translate, 0);

                        translate[data.translateInd] = old;
                    });

                    var oldShift = data.shift;
                        //скорость текущего сдвига
                    var shiftVelocity = Math.abs(oldShift - shift) / (1 + +new Date() - data.lastTime);

                    data.shift = shift; //это нужно для touchend
                    data.curDir = dir; //это нужно для touchend

                    //амортизируем текущую сорость пальца предыдущими замерами
                    data.velocity = 0.8 * shiftVelocity + 0.2 * data.velocity;
                }


                data.lastTime = +new Date();

                function normalizeShift(shift, constraint) {
                    if (!constraint) {
                        return 0;
                    } //если в данном направлении вобще нельзя двигать тогда аннулируем сдвиг

                    if (shift > constraint.max) {//если сдвиг больше максимума, тогда применяем пружинку, если она разрешена
                        return constraint.max + (options.rubberBand ? Math.pow(shift - constraint.max, options.rubberBandForce) : 0);
                    } else {
                        return shift;
                    }
                }
            },


            onTouchEnd: function (e) {
                e = e.originalEvent;

                var touches = e.touches;
                var data = this.data;
                var options = this.options;
                var constraints = data && data.constraints;
                var self = this;

                //если уже идет анимации доводки до нового состояния  тогда выходим
                if (this.animating) {
                    return;
                }

                //если на экране еще остались пальцы то выходим, подожем когда все отпустят
                //или же проверяем что тип события touchcancel
                if (touches.length && e.type != 'touchcancel') {
                    return;
                }

                //если мы даже не отслеживали жест это или нет, тогда можно смело игнорировать это событие
                if (!data) {
                    return;
                }

                //если мы отслеживали жест это иил нет, но так и не поняли этого, тогда выходим и сбрасываем данные о начале слежения
                if (!this.started) {
                    this.data = null;

                    return;
                }

                //закомментил, фастклик и так умеет супресить клик после драга
                //e.stopPropagation(); //чтобы не отрабатывал какой-либо клик по элементу за который тащили

                if (!data.noActionConstraints && !data.noActionMovement) {
                    //проверяем можно ли тянуть в ту сторону в которую тянули
                    //был ли сдвиг достаточным для срабатывания перехода в противоположное состояние
                    //и можно ли при сдвиге в данном направлении производить смену состояния
                    if (constraints[data.curDir] &&
                        !constraints[data.curDir].noTrigger &&
                        Math.abs(data.shift) >= options.actionTreshold) {
                        //запрашиваем дополнительные параметры авто анимации и времени вызова колбека непосредственно после отпускания пальца
                        //если есть соответсвующий колбек, бывают моменты когда важно понять это именно в самый последний момент
                        var dopParams = options.beforeAutoAnimation ? options.beforeAutoAnimation(data.curDir, data.shift) : null;
                        var autoAnimate = dopParams ? dopParams.autoAnimate : options.autoAnimate;
                        var immediateCallback = dopParams ? dopParams.immediateCallback : options.immediateCallback;

                        if (autoAnimate) {
                            //запускаем доводчик до нового состояния
                            this.animating = true;
                            var //рассчитываем сколько времени надо анимировать чтобы при текущей скорости пальца доанимировать до крайнего положения
                                calculatedDuration = (Math.abs(Math.abs(data.shift) - constraints[data.curDir].max)) / data.velocity;
                            var maxTransitionSpeed = options.getMaxTransitionSpeed ? options.getMaxTransitionSpeed() : options.maxTransitionSpeed;
                                //ограничиваем расчитанное время, чтобы не больше изначально выделенного на весь транзишен (по дизайну), и не меньше 100, чтобы не было мгновенного рывка при резком жесте пальцем
                            var duration = Math.max(Math.min(maxTransitionSpeed, calculatedDuration), options.minTransitionSpeed);
                            var isWaiting = false;

                            //анимируем все объекты до их положения в новом состоянии
                            data.$moveItems.each(function (ind, elem) {
                                //здесь кастомная проверка на то, надо ли сдвигать сейчас данный конкретный элемент или не стоит
                                if (!options.customMoveCheck || options.customMoveCheck($(this), data.shift)) {
                                    var translate = data.translate[ind];

                                    if (data.curDir == 'up' || data.curDir == 'left') {
                                        translate[data.translateInd] -= constraints[data.curDir].max;
                                    } else {
                                        translate[data.translateInd] += constraints[data.curDir].max;
                                    }


                                    if (!isWaiting) {
                                        //навешивать надо до установки трансформа
                                        utils.waitForTransitionEnd($(this), 'transform', function () {
                                            self.animating = false;
                                            //на страх и риск колбек вызываем ДО возврата инлайн стиля
                                            //иначе проблемы с транзишенами:
                                            //если ставить после, то возможна ситуация когда в колбеке идет какое либо обращение
                                            //к свойствам дум элементов которые могут принудительно заставить браузер сделать рефлоу (например считать положение объекта)
                                            //и тогда если на элементе есть транзишены, то браузер их применит и элемент начнет возвращаться в исходное состояние
                                            //даже несмотря на то, что в колбеке по идее будет проставляться класс, который должен установить элемент в конечное состояние в которое его автоматически довел плагин
                                            if (!immediateCallback) {
                                                options.callback(data.curDir);
                                            }

                                            //возвращаем обратно как было, пустая строка обязательно с пробелом, иначе функция не сбросит стиль, а просто вернет его значение
                                            data.$moveItems.each(function (ind, elem) {
                                                this.style.cssText = data.oldStyle[ind] || ' ';
                                            });

                                            data.$moveItems.removeClass('swiping');
                                        }, duration + 1000);

                                        isWaiting = true;
                                    }


                                    self.applyTransform(this, data.oldStyle[ind], translate, duration);
                                } else {
                                    //возвращаем обратно как было, пустая строка обязательно с пробелом, иначе функция не сбросит стиль, а просто вернет его значение
                                    this.style.cssText = data.oldStyle[ind] || ' ';
                                }
                            });

                            if (immediateCallback) {
                                options.callback(data.curDir);
                            }
                        } else {
                            //возвращаем обратно как было, пустая строка обязательно с пробелом, иначе функция не сбросит стиль, а просто вернет его значение
                            data.$moveItems.each(function (ind, elem) {
                                this.style.cssText = data.oldStyle[ind] || ' ';
                            });

                            options.callback(data.curDir);

                            data.$moveItems.removeClass('swiping');
                        }
                    } else {
                        data.$moveItems.removeClass('swiping');

                        options.callback();

                        //возвращаем обратно как было, пустая строка обязательно с пробелом, иначе функция не сбросит стиль, а просто вернет его значение
                        data.$moveItems.each(function (ind, elem) {
                            this.style.cssText = data.oldStyle[ind] || ' ';
                        });
                    }
                }

                this.data = null;
                this.started = null;
            },


            //трансформ и транзишен надо за один раз назначать, чтобы не было двух пересчетов стилей
            //да и делать это надо нативно, причем не считыва заново obj.style.cssText
            //а использовать исходное сохраненное значение и к нему добавлять трансформы и транзишены
            applyTransform: function (obj, oldStyle, translate, duration) {
                //очень важно чтобы в матрице translate не было чисел в экспонентном виде,
                //поскольку мы имеем дело с числами с плавающей точкой,
                //то 0 вполне может быть представлен (и как выяснилось представляется в реальности) например в виде -0.00000000000000024492935982947064
                //а потом эта белиберда в процессе работы трансформируется во что-то типа -2.4492935982947064e-16 (например если сделать массиву с такими числами .join(','))
                //а такая запись если использовать ее для матрицы трансформации в css уже не является валидной, шах и мат
                //вот потому мы и отрезаем незначащие разряды (но это не дает гарантии что )
                var x = Math.round(translate[0] * 100000) / 100000;
                var y = Math.round(translate[1] * 100000) / 100000;
                var transform = 'translateX(' + x + 'px) translateY(' + y + 'px) translateZ(0)';
                var transition = 'transform ' + duration + 'ms ease';
                var transformStr = '';
                var transitionStr = '';

                transformStr += '-webkit-transform: ' + transform + ';';
                transformStr += '-ms-transform: ' + transform + ';';
                transformStr += 'transform: ' + transform + ';';

                transitionStr += '-webkit-transition: -webkit-' + transition + ';';
                transitionStr += 'transition: ' + transition + ';';

                obj.style.cssText = oldStyle + ';' + transformStr + transitionStr;
            }

        };


        var $elems = $(this);

        var swiper = new Swiper(options, $elems);

        swiper.initialize();

        $elems.data('swiper', swiper);

        return this;
    };
})(jQuery);
/* eslint-enable */

module.exports = utils;
